import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderWGE from "../../../../src/content/wg-easter-devotional-free/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderWGE,
  React
};